




































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
@Component({
  components: { BPopover },
})
export default class FundamentalLetter extends Vue {}
